const Svg = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 12 8"
      className={className}
    >
      <path
        d="M-6.16331e-08 6.29508L1.41 7.70508L6 3.12508L10.59 7.70508L12 6.29508L6 0.295078L-6.16331e-08 6.29508Z"
        fill="#456AD1"
      />
    </svg>
  );
};

export default Svg;
